import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import ProductCard from "../card/ProductCard";
import { listProduct, searchFilters } from "../function/product";
import { listCategory } from "../function/category";
import { listCategoryService } from "../function/categoryservice";

import "./Shop.css";

const Shop = () => {
  const [product, setProduct] = useState([]);
  const [loading, setLoading] = useState(false);
  const [price, setPrice] = useState(["", ""]);
  const [ok, setOk] = useState(false);

  const [category, setCategory] = useState([]);
  const [categorySelect, setCategorySelect] = useState([]);
  const [categoryType, setCategoryType] = useState("");

  // mobile filter toggle
  const [filterOpen, setFilterOpen] = useState(false);

  const { search } = useSelector((state) => ({ ...state }));
  const { text } = search;
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const loadData = () => {
    setLoading(true);
    listProduct(100)
      .then((res) => {
        setProduct(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log("Load Data Error:", err);
      });
  };

  const fetchDataFilter = (arg) => {
    searchFilters(arg)
      .then((res) => setProduct(res.data))
      .catch((err) => console.log("Search Filter Error:", err));
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      const params = new URLSearchParams(location.search);
      const categoryId = params.get("categoryId");
      if (text && text.trim() !== "") {
        fetchDataFilter({ query: text });
      } else if (categoryId) {
        fetchDataFilter({ category: [categoryId] });
      } else {
        loadData();
      }
    }, 300);
    return () => clearTimeout(delay);
  }, [text, location.search]);

  useEffect(() => {
    if (ok) {
      const min = price[0] !== "" ? parseInt(price[0]) : 0;
      const max = price[1] !== "" ? parseInt(price[1]) : 999999999;
      fetchDataFilter({ price: [min, max] });
    }
  }, [ok]);

  const handlePriceInput = (e, index) => {
    const value = e.target.value;
    const newPrice = [...price];
    newPrice[index] = value;
    setPrice(newPrice);
    if (newPrice[0] !== "" || newPrice[1] !== "") {
      setTimeout(() => setOk((prev) => !prev), 400);
    }
  };

  const handleCategoryTypeChange = (e) => {
    const value = e.target.value;
    setCategoryType(value);
    setCategorySelect([]);
    if (value === "category") {
      listCategory().then((res) => setCategory(res.data));
    } else if (value === "categoryservice") {
      listCategoryService().then((res) => setCategory(res.data));
    } else {
      setCategory([]);
    }
  };

  const handleTagClick = (id) => {
    setCategorySelect((prev) => {
      const next = prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id];
      if (next.length > 0) {
        fetchDataFilter({ category: next });
      } else {
        loadData();
      }
      return next;
    });
  };

  const handleApply = () => {
    const min = price[0] !== "" ? parseInt(price[0]) : 0;
    const max = price[1] !== "" ? parseInt(price[1]) : 999999999;
    if (categorySelect.length > 0) {
      fetchDataFilter({ price: [min, max], category: categorySelect });
    } else if (price[0] !== "" || price[1] !== "") {
      fetchDataFilter({ price: [min, max] });
    } else {
      loadData();
    }
    setFilterOpen(false); // ปิด filter หลังค้นหาบนมือถือ
  };

  const handleReset = () => {
    setPrice(["", ""]);
    setCategorySelect([]);
    setCategoryType("");
    setCategory([]);
    loadData();
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoryTypeFromUrl = params.get("categoryType");
    const categoryIdFromUrl = params.get("categoryId");
    const categorySlugFromUrl = params.get("category");

    setCategoryType(categoryTypeFromUrl || "");

    const fetchCategoriesAndFilter = async () => {
      let categoriesData = [];
      if (categoryTypeFromUrl === "category") {
        const res = await listCategory();
        categoriesData = res.data;
        setCategory(res.data);
      } else if (categoryTypeFromUrl === "categoryservice") {
        const res = await listCategoryService();
        categoriesData = res.data;
        setCategory(res.data);
      } else {
        setCategory([]);
      }

      let selectedCategoryId = null;
      if (categoryIdFromUrl) {
        selectedCategoryId = categoryIdFromUrl;
      } else if (categorySlugFromUrl) {
        const found = categoriesData.find((item) => item.slug === categorySlugFromUrl);
        if (found) selectedCategoryId = found._id;
      }

      if (selectedCategoryId) {
        setCategorySelect([selectedCategoryId]);
        fetchDataFilter({ category: [selectedCategoryId] });
      } else {
        loadData();
      }
    };

    fetchCategoriesAndFilter();
  }, [location.search]);

  return (
    <div className="container">
      <div className="shop-layout">

      {/* ===== Mobile: ปุ่มเปิด/ปิด Filter ===== */}
      <button
        className="filter-toggle-btn"
        onClick={() => setFilterOpen((prev) => !prev)}
        aria-expanded={filterOpen}
      >
        <span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 6h16M8 12h8M11 18h2" />
          </svg>
          ตัวกรอง
        </span>
        <span style={{ fontSize: 18, color: "#aaa" }}>{filterOpen ? "▲" : "▼"}</span>
      </button>

      {/* ===== Sidebar ===== */}
      <aside className={`sidebar-filter ${filterOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 6h16M8 12h8M11 18h2" stroke="currentColor" />
          </svg>
          ตัวกรอง
        </div>

        <hr className="sidebar-divider" />

        {/* Price */}
        <div className="filter-section">
          <span className="filter-label">ช่วงราคา (บาท)</span>
          <div className="price-row">
            <input
              type="number"
              className="price-input"
              placeholder="ต่ำสุด"
              value={price[0]}
              onChange={(e) => handlePriceInput(e, 0)}
            />
            <span className="price-sep">—</span>
            <input
              type="number"
              className="price-input"
              placeholder="สูงสุด"
              value={price[1]}
              onChange={(e) => handlePriceInput(e, 1)}
            />
          </div>
        </div>

        <hr className="sidebar-divider" />

        {/* Category Type */}
        <div className="filter-section">
          <span className="filter-label">ประเภทหมวดหมู่</span>
          <div className="select-wrap">
            <select
              className="filter-select"
              value={categoryType}
              onChange={handleCategoryTypeChange}
            >
              <option value="">เลือกประเภท</option>
              <option value="category">หมวดหมู่สินค้า 360</option>
              <option value="categoryservice">หมวดหมู่สินค้าบริการ</option>
            </select>
            <span className="select-chevron">▾</span>
          </div>
        </div>

        {/* Category Tags */}
        {category.length > 0 && (
          <div className="filter-section">
            <span className="filter-label">หมวดหมู่</span>
            <div className="tag-list">
              {category.map((item) => (
                <span
                  key={item._id}
                  className={`cat-tag ${categorySelect.includes(item._id) ? "active" : ""}`}
                  onClick={() => handleTagClick(item._id)}
                >
                  {item.name}
                </span>
              ))}
            </div>
          </div>
        )}

        <hr className="sidebar-divider" />

        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <button className="btn-apply" onClick={handleApply}>ค้นหา</button>
          <button className="btn-reset" onClick={handleReset}>รีเซ็ต</button>
        </div>
      </aside>

      {/* ===== Product Area ===== */}
      <div className="product-area">
        <p className="product-area-title mt-3">
          {loading ? "กำลังโหลด..." : `พบ ${product.length} รายการ`}
        </p>

        {product.length === 0 && !loading && (
          <p style={{ color: "#aaa", fontSize: "14px", fontFamily: "'Kanit', sans-serif" }}>
            ไม่พบสินค้า
          </p>
        )}

        <div className="row g-2 mt-3 ">
          {product.map((item, index) => (
            <div key={index} className="col-6 col-sm-6 col-md-4 col-lg-3 mb-3">
              <ProductCard product={item} />
            </div>
          ))}
        </div>
      </div>
    </div>
    </div>
    
  );
};

export default Shop;